@import "/src/variables/tokens";
@import "/src/variables/color";
@import "/src/variables/z-index";
@import "/src/variables/breakpoints";
.modal {
  height: 100dvh;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: $breakpoint-mobile-max) {
    // align-items: flex-start;
  }
  background: $zv-overlay--rgba-Neutral-Darkest-0-8;
  overscroll-behavior: contain !important;
  //   padding-bottom: 50px;
  z-index: $z-index-popup;
  &.nested {
    z-index: $z-index-popup-nested;
  }
  .backdrop {
    position: absolute;
    height: 100%;
    width: 100%;
    display: none;
  }

  &.isOpen {
    // animation-name: modalShow;
    // animation-duration: 5s;
    -webkit-animation: modalShow 1s; /* Chrome, Safari, Opera */
    animation: modalShow 1s;
      background: $zv-overlay--rgba-Neutral-Darkest-0-8 !important;
    // z-index: 100000;
    // display: flex;

    // @media screen and (max-width: 800px) {
    //   overflow-x: none;
    // }
    @keyframes modalShow {
      from {
        opacity: 0;
        display: none;
      }
      to {
        opacity: 1;
        display: flex;
      }
    }
  }
  &.hide {
    -webkit-animation: modalHide 0.5s; /* Chrome, Safari, Opera */
    animation: modalHide 0.5s;
    display: none;
    opacity: 0;
    @keyframes modalHide {
      from {
        opacity: 1;
        display: flex;
      }
      to {
        opacity: 0;
        display: none;
      }
    }
  }

  // Handoff dialogs (DialogPopup `disableEnterAnimation`): render at full opacity
  // immediately instead of re-running `modalShow` from opacity 0, so the dark
  // backdrop doesn't reset to transparent when one dialog replaces another.
  &.noEnterAnim.isOpen {
    -webkit-animation: none !important;
    animation: none !important;
    opacity: 1;
  }
}
